<dx-box
    #workOrderBox
    width="100%"
    height="100%"
    direction="col"
    [elementAttr]="{ id: 'workOrderBox' + (!widgetId ? '' : widgetId) }"
>
    <dxi-item baseSize="auto">
        <h2 class="page-header">
            {{ pageTitle }}
            <sup *ngIf="helpLink" class="page-help-icon">
                <a [href]="helpLink" target="_blank" [class]="iconHelp"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background">
        <dx-box width="100%" height="100%" direction="col" class="work-order-box-container">
            <dxi-item baseSize="auto" *ngIf="!showOnlyLinked">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <dx-tabs
                                    [width]="280"
                                    class="cc-tabs"
                                    [dataSource]="tabItems"
                                    [(selectedItem)]="selectedTabItem"
                                ></dx-tabs>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="!isPopup" baseSize="auto">
                            <div *dxTemplate class="toolbar-container">
                                <dx-toolbar>
                                    <dxi-item
                                        *ngIf="isInternalUser"
                                        location="after"
                                        widget="dxButton"
                                        [options]="{
                                            type: 'default',
                                            template: 'multiIconTemplate',
                                            text: addWorkOrderButtonOptions,
                                            hint: 'Add New Work Order',
                                            onClick: onNewWorkOrderClick
                                        }"
                                    ></dxi-item>
                                    <app-multi-icon-button-template>
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="POST"
                                            apiUrl="api/workorder/action"
                                        ></app-security-info>
                                    </app-multi-icon-button-template>
                                </dx-toolbar>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div
                    *dxTemplate
                    class="work-order-content"
                    [ngClass]="{ 'work-order-content-border dx-theme-border-color': isPopup }"
                >
                    <div class="full-width full-height">
                        <ng-container *ngIf="selectedTabItem.name === 'openWorkOrders'">
                            <app-open-work-orders
                                #openWorkOrders
                                [isPopup]="isPopup"
                                [communityId]="communityId"
                                [vendorId]="vendorId"
                                [workOrderIds]="workOrderIds"
                                [selectedWorkOrderId]="workOrderId"
                                [customerId]="customerId"
                                [workflowId]="workflowId"
                                [showOnlyLinked]="showOnlyLinked"
                                (onWorkOrderSelection)="onWorkOrderRecordsSelection($event)"
                                (onWorkOrderDeselection)="onWorkOrderRecordsDeselection($event)"
                            ></app-open-work-orders>
                        </ng-container>
                        <ng-container *ngIf="selectedTabItem.name === 'closedWorkOrders'">
                            <app-closed-work-orders
                                #closedWorkedOrders
                                [isPopup]="isPopup"
                                [communityId]="communityId"
                                [vendorId]="vendorId"
                                [workOrderIds]="workOrderIds"
                                [selectedWorkOrderId]="workOrderId"
                                [customerId]="customerId"
                                [workflowId]="workflowId"
                                (onWorkOrderSelection)="onWorkOrderRecordsSelection($event)"
                                (onWorkOrderDeselection)="onWorkOrderRecordsDeselection($event)"
                            ></app-closed-work-orders>
                        </ng-container>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<app-work-orders-editor
    *ngIf="showWorkOrderEditor"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [customerId]="customerId"
    (onClose)="onEditorClose($event)"
    (onManageProposalShow)="onManageProposalShow($event)"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow($event)"
></app-work-orders-editor>

<app-manage-work-order-authorization
    *ngIf="showManageWorkAuthorization"
    [workOrderId]="workOrderId"
    [communityId]="communityId"
    (onClose)="onManageWorkorderAuthorizationClose()"
    (onManageProposalShow)="onManageProposalShow()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
></app-manage-work-order-authorization>

<app-manage-work-order-proposals
    *ngIf="showManageProposals"
    [workOrderId]="workOrderId"
    [communityId]="communityId"
    (onClose)="onManageProposalClose()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow()"
></app-manage-work-order-proposals>

<dx-load-panel
    [position]="{ of: !widgetId ? 'body' : '#workOrderBox' + widgetId }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="!widgetId"
    [shading]="!widgetId"
    [closeOnOutsideClick]="false"
></dx-load-panel>
